import DisclosureBanner from './DisclosureBanner'

export default DisclosureBanner